export enum InputTypes {
  button = 'button', // Кнопка.
  checkbox = 'checkbox', // Флажки. Позволяют выбрать более одного варианта из предложенных.
  file = 'file', // Поле для ввода имени файла, который пересылается на сервер.
  hidden = 'hidden', // Скрытое поле. Оно никак не отображается на веб-странице.
  image = 'image', // Поле с изображением. При нажатии на рисунок данные формы отправляются на сервер.
  password = 'password', // Обычное текстовое поле, но отличается от него тем, что все символы показываются звездочками. Предназначено для того, чтобы никто не подглядел вводимый пароль.
  radio = 'radio', // Переключатели. Используются, когда следует выбрать один вариант из нескольких предложенных.
  reset = 'reset', // Кнопка для возвращения данных формы в первоначальное значение.
  submit = 'submit', // Кнопка для отправки данных формы на сервер.
  text = 'text', // Текстовое поле. Предназначено для ввода символов с помощью клавиатуры.
  color = 'color', // Виджет для выбора цвета.
  date = 'date', // Поле для выбора календарной даты.
  datetime = 'datetime', // Указание даты и времени.
  datetimeLocal = 'datetime-local', // Указание местной даты и времени.
  email = 'email', // Для адресов электронной почты.
  number = 'number', // Ввод чисел.
  range = 'range', // Ползунок для выбора чисел в указанном диапазоне.
  search = 'search', // Поле для поиска.
  tel = 'tel', // Для телефонных номеров.
  time = 'time', // Для времени.
  url = 'url', // Для веб-адресов.
  month = 'month', // Выбор месяца.
  week = 'week', // Выбор недели.
  // =---------------------------,
  textarea = 'textarea',
  select = 'select',
  autocomplete = 'autocomplete',
}

export default InputTypes;
